export const SizesSubTitle = [
  {
    text: "Use size of avatar like ",
    code: ".img- *  (70/80/90/100)",
  },
  {
    text: " class.",
  },
];

export const StatusSubTitle = [
  {
    text: "Use status of avatar like ",
    code: " .status-* (online/offline/dnd)",
  },
];

export const ShapesSubTitle = [
  {
    text: "Use shapes of avatar like",
    code: ".b-r-* (8/30/35/25)",
  },
];

export const RatioSubTitle = [
  {
    text: "Use shape to avatar using ",
    code: ".radio",
  },
  {
    text: " and",
    code: " img-* (50/70/80/90/100)",
  },
  {
    text: " class.",
  },
];

export const GroupSubTitle = [
  {
    text: "Use group of avatars like ",
    code: ".img-* (40/50/60/80/100) ",
  },
  {
    text: "and",
    code: " .b-r-* (8/30/35)",
  },
  {
    text: ".",
  },
];

export const AvatarSizeData = [
  {
    class: "100",
    image: "3.jpg",
  },
  {
    class: "90",
    image: "4.jpg",
  },
  {
    class: "80",
    image: "7.jpg",
  },
  {
    class: "70",
    image: "11.jpg",
  },
];

export const AvatarStatusData = [
  {
    class: "100",
    image: "user/1.jpg",
    status: "success",
  },
  {
    class: "90",
    image: "avtar/16.jpg",
    status: "warning",
  },
  {
    class: "80",
    image: "avtar/7.jpg",
    status: "danger",
  },
  {
    class: "70",
    image: "avtar/3.jpg",
    status: "success",
  },
];

export const AvatarShapeData = [
  {
    class: "100 b-r-8",
    image: "4.jpg",
  },
  {
    class: "90 b-r-30",
    image: "16.jpg",
  },
  {
    class: "80 b-r-35",
    image: "3.jpg",
  },
  {
    class: "70 rounded-circle",
    image: "11.jpg",
  },
];

export const AvatarRatioData = [
  {
    class: "100",
    image: "avtar/11.jpg",
  },
  {
    class: "90",
    image: "avtar/4.jpg",
  },
  {
    class: "80",
    image: "user/1.jpg",
  },
  {
    class: "70",
    image: "avtar/16.jpg",
  },
  {
    class: "50",
    image: "avtar/7.jpg",
  },
];

export const AvatarGroupData = [
  {
    id: 1,
    child: [
      {
        id: 1,
        class: "100 b-r-8",
        image: "avtar/4.jpg",
      },
      {
        id: 2,
        class: "80 b-r-30",
        image: "avtar/16.jpg",
      },
      {
        id: 3,
        class: "50 b-r-35",
        image: "avtar/3.jpg",
      },
    ],
  },
  {
    id: 2,
    child: [
      {
        id: 1,
        class: "60 rounded-circle",
        image: "avtar/16.jpg",
      },
      {
        id: 2,
        class: "80 b-r-8",
        image: "user/1.jpg",
      },
      {
        id: 3,
        class: "60 rounded-circle",
        image: "avtar/16.jpg",
      },
    ],
  },
  {
    id: 3,
    child: [
      {
        id: 1,
        class: "40 rounded-circle",
        image: "user/3.jpg",
      },
      {
        id: 2,
        class: "40 rounded-circle",
        image: "user/5.jpg",
      },
      {
        id: 3,
        class: "40 rounded-circle",
        image: "user/1.jpg",
      },
    ],
  },
];

export const AvatarInitialSubTitle = [
  {
    text: "Use initial letter as a avatar.",
  },
];

export const AvatarInitialData = [
  { id: 1, color: "primary", text: "P" },
  { id: 2, color: "secondary", text: "I" },
  { id: 3, color: "danger", text: "X" },
  { id: 4, color: "primary", text: "E" },
  { id: 5, color: "secondary", text: "L" },
];

export const BadgeIndicatorSubTitle = [
  {
    text: "Use",
    code: "badge",
  },
  {
    text: "class with avatar to indicate and provide indication.",
  },
];

export const BadgeIndicatorData = [
  {imageClass:"img-100",image:"user/1.jpg",color:"success",class:"top-0 start-0",text:"A"},
  {imageClass:"img-90",image:"avtar/16.jpg",color:"warning",class:"bottom-0 end-0",text:"C"},
  {imageClass:"img-80",image:"avtar/7.jpg",color:"danger",class:"top-0 end-0",text:"D"},
  {imageClass:"img-70",image:"avtar/3.jpg",color:"success",class:"bottom-0 start-0",text:"B"},
]

export const AnimatedAvatarSubTitle = [
  {
    text: "Use",
    code: "animation-ping",
  },
  {
    text: "class with avatar to indicate",
    code: "active / offline / dnd",
  },
  {
    text: "status.",
  }
];

export const AnimatedAvatarData = [
  {imageClass:"img-100",image:"user/1.jpg",color:"success"},
  {imageClass:"img-90",image:"avtar/16.jpg",color:"warning"},
  {imageClass:"img-80",image:"avtar/7.jpg",color:"danger"},
  {imageClass:"img-70",image:"avtar/3.jpg",color:"success"},
]